import { action } from 'satcheljs';
import type { CalendarCloudSettingType } from '../store/schema/CalendarCloudSettingType';
import type { MailboxInfo } from 'owa-client-types';

/**
 * Announces that calendar cloud settings has been updated and includes
 * which settings were updated
 */
export interface CalendarAccountCloudSettingSavedActionMessage {
    mailboxInfo: MailboxInfo;
    calendarCloudSettingTypes: CalendarCloudSettingType[];
}
export const calendarAccountCloudSettingUpdated: (
    mailboxInfo: MailboxInfo,
    calendarCloudSettingTypes: CalendarCloudSettingType[]
) => CalendarAccountCloudSettingSavedActionMessage = action(
    'calendarAccountCloudSettingSaved',
    (
        mailboxInfo: MailboxInfo,
        calendarCloudSettingTypes: CalendarCloudSettingType[]
    ): CalendarAccountCloudSettingSavedActionMessage => ({
        mailboxInfo,
        calendarCloudSettingTypes,
    })
);
